<template>
	<div
		ref="grid"
		:class="gridWidth"
		class="grid scroll"
	>
		<slot />
	</div>
</template>

<script>
export default {
	data() {
		return {
			gridWidth: '',
		};
	},
	mounted() {
		this.adaptGridWidth();
		window.addEventListener('resize', this.adaptGridWidth);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.adaptGridWidth);
	},
	methods: {
		adaptGridWidth() {
			if (this.$refs.grid) {
				const width = this.$refs.grid.offsetWidth;
				let size = 'xlarge';

				if (width <= 420) {
					size = 'mobile';
				} else if (width <= 500) {
					size = 'xsmall';
				} else if (width <= 820) {
					size = 'small';
				} else if (width <= 1040) {
					size = 'medium';
				} else if (width <= 1240) {
					size = 'regular';
				} else if (width <= 1500) {
					size = 'large';
				}

				this.gridWidth = `grid--${size}`;
			}
		},
	},
};
</script>

<style lang="scss" scoped src="./grid.scss" />
